import {
  Container,
  Title,
  StyledLink,
  Inner,
  Button,
  DividerWrapper,
} from '../../styles';
import { SERVICES_INFO } from '../../../../constants';
import React, { useState } from 'react';
import { Divider } from '../../../Divider/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';

export const Services = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <Container>
      <Title>{SERVICES_INFO.TITLE}</Title>
      <Button onClick={() => setIsOpen(prev => !prev)}>
        {SERVICES_INFO.TITLE}
        {<FontAwesomeIcon icon={isOpen ? faChevronDown : faChevronRight} />}
      </Button>

      <Inner $active={isOpen}>
        <StyledLink href={process.env.REACT_APP_LINK_SERVICES_MOBILE}>
          {SERVICES_INFO.MOBILE}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_SERVICES_BACK_END}>
          {SERVICES_INFO.BACK_END}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_SERVICES_DESIGN}>
          {SERVICES_INFO.DESIGN}
        </StyledLink>
        <StyledLink href={process.env.REACT_APP_LINK_SERVICES_QA}>
          {SERVICES_INFO.QA}
        </StyledLink>
      </Inner>
      <DividerWrapper>
        <Divider />
      </DividerWrapper>
    </Container>
  );
};
